import { render, staticRenderFns } from "./AdminNotificationsForm.vue?vue&type=template&id=0c079b89&"
import script from "./AdminNotificationsForm.vue?vue&type=script&lang=js&"
export * from "./AdminNotificationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports